<template>
  <div class="container-fluid">
    <div align="left">
        <el-form
            style="margin-top: 15px"
            size="large"
            :inline="true"
            :model="search"
        >
            <el-form-item>
                <el-date-picker
                    v-model="search.start_time"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    type="datetime"
                    size="large"
                    placeholder="start time"
                    default-time="00:00:00"
                ></el-date-picker>
            </el-form-item>
            <el-form-item>至</el-form-item>
            <el-form-item>
                <el-date-picker
                    v-model="search.end_time"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    type="datetime"
                    size="large"
                    placeholder="end time"
                    default-time="23:59:59"
                ></el-date-picker>
            </el-form-item>
            <el-form-item label="公仔名称：" style="margin-left:20px;">
                <el-select v-model="search.crafite_uuid" filterable placeholder="craftie name">
                    <el-option v-for="item in crafite_list" :key="item.crafite_uuid" :value="item.crafite_uuid" :label="item.crafite_name"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" icon="el-icon-search" @click="toSearch()">查询</el-button>
            </el-form-item>
        </el-form>
    </div>
    <div style="margin-bottom: 6px">
      <div>
        <div style="float: right;margin-bottom: 16px;">
          <el-button class="el-button--primary" icon="el-icon-video-camera-solid" @click="goProduct()">生产统计</el-button>
        </div>
      </div>
      <el-table v-tb-height="{self:this}" ref="table" border :data="data_list" :height="height" empty-text="Temporarily no data">
        <el-table-column label="No" type="index"></el-table-column>
        <el-table-column align="center" label="公仔名称" prop="crafite_name" ></el-table-column>
        <el-table-column align="center" label="公仔id" prop="craftie_no">
            <template slot-scope="scope">
                <a @click="copy(scope.row.craftie_no)" style="color:#409EFF;">{{scope.row.craftie_no}}</a>
            </template>
        </el-table-column>
        <el-table-column align="center" label="数量" prop="counts" min-width="50px"></el-table-column>
        <el-table-column align="center" label="开始时间" prop="">
          <template slot-scope="scope">
            <el-date-picker
                    v-model="scope.row.min_time"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    type="datetime"
                    size="large"
                    placeholder="start time"
                    default-time="00:00:00"
                    @change="itemSearch(scope.$index,scope.row)"
            ></el-date-picker>
          </template>
        </el-table-column>
        <el-table-column align="center" label="结束时间" prop="">
          <template slot-scope="scope">
            <el-date-picker
                    v-model="scope.row.max_time"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    type="datetime"
                    size="large"
                    placeholder="end time"
                    default-time="23:59:59"
                    @change="itemSearch(scope.$index,scope.row)"
            ></el-date-picker>
          </template>
        </el-table-column>
        <el-table-column align="center" min-width="50px" label="operator">
          <template slot-scope="scope">
            <el-button type="primary" size="medium" icon="el-icon-s-operation" @click="showItem(scope.row)">查询</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog
      title="Crafties Detail"
      :visible.sync="itemflag"
      @close="itemflag=false"
      destroy-on-close
      top="10vh"
      width="65%"
    >
      <CraftieItemSearch v-if="itemflag" :chooseItem="chooseItem" @close="itemflag=false"></CraftieItemSearch>
    </el-dialog>
  </div>
</template>

<script>
import CraftieItemSearch from './CraftieItemSearch'

  export default {
    name: 'CraftiesSearch',
    components: {CraftieItemSearch},
    data () {
      return {
        height: 0,
        itemflag: false,
        search: {
            crafite_uuid: '',
            start_time: this.getNextDate(-7)+" 00:00:00",
            end_time: this.getNextDate(0)+" 23:59:59",
        },
        crafite_list:[],
        data_list: []
      }
    },
    computed: {},
    created () {
        this.initData()
    },
    mounted(){
        this.toSearch();
    },
    methods: {
        copy(data){
            let url = data;
            let oInput = document.createElement('input');
            oInput.value = url;
            document.body.appendChild(oInput);
            oInput.select(); // 选择对象;
            document.execCommand("Copy"); // 执行浏览器复制命令
            this.$message({
            message: '复制成功',
            type: 'success'
            });
            oInput.remove()
        },
        getNextDate: function (day) {
            var dd = new Date();
            dd.setDate(dd.getDate() + day);
            var y = dd.getFullYear();
            var m =
                dd.getMonth() + 1 < 10 ? "0" + (dd.getMonth() + 1) : dd.getMonth() + 1;
            var d = dd.getDate() < 10 ? "0" + dd.getDate() : dd.getDate();
            return y + "-" + m + "-" + d;
        },
        initData () {
            this.$api.rootV1.get('/web/craftiesearch/init', {}, (res) => {
                this.crafite_list=res.data.crafite_list;
            })
        },
        toSearch () {
            this.$api.rootV1.post('/web/craftiesearch/search', this.search, (res) => {
                if(res.errcode===0){
                    this.data_list=res.data;
                }
            })
        },
        itemSearch (index,row) {
            let params = {
                crafite_uuid: row.craftie_no,
                start_time: row.min_time,
                end_time: row.max_time,
            };
            console.log(index,row)
            this.$api.rootV1.post('/web/craftiesearch/search', params, (res) => {
                if(res.errcode===0){
                    this.data_list[index].counts=res.data[0].counts;
                }
            })
        },
        goProduct () {
            this.$router.push({name: 'productSearch'})
        },
        showItem(row){
            this.chooseItem={
                start_time: row.min_time,
                end_time: row.max_time,
                crafite_uuid: row.craftie_no,
                counts: row.counts,
                crafite_name: row.crafite_name
            }
            this.itemflag=true
        },

    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/main/craftieSearch/CraftieSearch.vue